// extracted by mini-css-extract-plugin
export default {"container":"style_container__8Kc7y","centeredWrapper":"style_centeredWrapper__A+2s2"};